import styled from 'styled-components'

import GuideSection from '~/features/corporate-participation/components/GuideSection'
import TopSection from '~/features/corporate-participation/components/TopSection'
import ImageFromBucket from '~/shared/components/common/ImageFromBucket'
import theme from '~/shared/styles/theme'

function CorporateInfoPage() {
  return (
    <Wrapper>
      <BackgroundImage
        src="assets/background/corp-only-bg-2560.webp"
        alt="Background Image"
      />
      <TopSection />
      <GuideSection />
    </Wrapper>
  )
}

export default CorporateInfoPage

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: ${theme.size.headerHeight}px;

  @media ${theme.device.large} {
    gap: 48px;
    padding: 0 60px;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: ${theme.size.mobileHeaderHeight}px;
    padding: 0 20px;
  }
`

const BackgroundImage = styled(ImageFromBucket)`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  width: 100%;
  height: 550px;

  object-fit: cover;
  background-color: ${theme.colors.grey_2};

  @media ${theme.device.medium} {
    height: 450px;
    object-fit: cover;
  }
`
